import React from 'react';
import { MenuItemModel } from './types.ts';
import SubMenuItem from './SubMenuItem.tsx';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { isNotNullOrUndefined } from '@utils/utils.tsx';
import SvgMenuRight from '@components/icons/admin/MenuRight.tsx';
import { Link } from '@tanstack/react-router';
import SvgMenuDown from '@components/icons/admin/MenuDown.tsx';

const MenuItem: React.FC<MenuItemModel> = ({ title, icon, note, subMenu, elementCount, url, mode = 'open-inside', isOpen = false, smallMenu = false, onClick }) => {
  return (
    <>
      <li className={'group relative cursor-pointer select-none'}>
        <div
          onClick={e => onClick && onClick(e)}
          className={twMerge(
            clsx(
              'flex px-4 py-3 items-center justify-between transition-all duration-150 border-l-[3px] border-transparent',
              'hover:bg-gray-50',
              { 'justify-center': smallMenu },
              { 'bg-primary/10 border-l-[3px] border-primary': isOpen },
            ),
          )}
        >
          <Link to={url ?? '#'} className={'flex gap-3 items-center'}>
            {icon && (
              <span className={twMerge(clsx('text-gray-400 transition-colors', { 'text-primary': isOpen }))}>
                {icon}
              </span>
            )}
            {!smallMenu && (
              <>
                {note ? (
                  <div className={'flex-col flex'}>
                    <span className={twMerge(clsx('text-[13px] font-medium text-gray-600', { 'text-primary font-semibold': isOpen }))}>{title}</span>
                    <span className={'text-xs text-gray-400'}>{note}</span>
                  </div>
                ) : (
                  <span className={twMerge(clsx('text-[13px] font-medium text-gray-600', { 'text-primary font-semibold': isOpen }))}>{title}</span>
                )}
              </>
            )}
          </Link>
          <div className={'flex flex-row items-center gap-2'}>
            {elementCount > 0 && elementCount < 10 && (
              <div className="flex items-center justify-center min-w-[18px] h-[18px] px-1.5 bg-primary text-[10px] font-semibold text-white rounded-full">{elementCount}</div>
            )}
            {elementCount > 9 && elementCount < 100 && (
              <div className="flex items-center justify-center px-1.5 h-[18px] bg-primary text-[10px] font-semibold text-white rounded-full">{elementCount}</div>
            )}
            {elementCount > 99 && <div className="flex items-center justify-center px-1.5 h-[18px] bg-primary text-[10px] font-semibold text-white rounded-full">99+</div>}
            {subMenu && Array.isArray(subMenu) && !smallMenu && (
              <span className={twMerge(clsx('text-gray-400', { 'text-primary': isOpen }))}>
                {mode == 'open-inside' && subMenu && subMenu?.length > 0 && !isOpen && <SvgMenuRight />}
                {mode == 'open-inside' && subMenu && subMenu?.length > 0 && isOpen && <SvgMenuDown />}
                {mode != 'open-inside' && subMenu && subMenu?.length > 0 && isOpen && <SvgMenuRight />}
              </span>
            )}
            {subMenu && !Array.isArray(subMenu) && !smallMenu && <span className="text-gray-400">{mode != 'open-inside' && subMenu && <SvgMenuRight />}</span>}
          </div>
        </div>

        {subMenu && !smallMenu && (
          <ul
            className={twMerge(
              clsx(
                'w-[270px]',
                {
                  'hidden absolute group-hover:block left-[270px] top-0 shadow-lg bg-white border border-gray-200 z-20 py-1': mode === 'open-outside-top',
                },
                {
                  'hidden absolute group-hover:block left-[270px] bottom-0 shadow-lg bg-white border border-gray-200 z-20 py-1': mode === 'open-outside-bottom',
                },
                { 'hidden': mode === 'open-inside' && !isOpen },
                { 'bg-gray-50/50': mode === 'open-inside' && isOpen },
              ),
            )}
          >
            {Array.isArray(subMenu) && (
              <>
                {subMenu
                  .filter(t => t.render)
                  .map((subItem, index) => {
                    return <SubMenuItem key={index} title={subItem.title} onClick={subItem.onClick} url={subItem.url} />;
                  })}
              </>
            )}
            {isNotNullOrUndefined(subMenu) && !Array.isArray(subMenu) && <>{subMenu}</>}
          </ul>
        )}
      </li>
    </>
  );
};

export default MenuItem;
